import { ICompassusDashboardService } from "../../core/impl/compassusDashboardServiceImpl";

export const CompassusDashboardControllerFactory = ({
  compassusDashboardService,
}: {
  compassusDashboardService: ICompassusDashboardService;
}) => {
  return {
    getProductivity: compassusDashboardService.getProductivity,
    getProductivitySummary: compassusDashboardService.getProductivitySummary,
    getProductivityProviders:
      compassusDashboardService.getProductivityProviders,
    getProductivityUtilization:
      compassusDashboardService.getProductivityUtilization,
    getEngagementUtilization:
      compassusDashboardService.getEngagementUtilization,
    getPtoRecords: compassusDashboardService.getPtoRecords,
    createPtoRecord: compassusDashboardService.createPtoRecord,
    updatePtoRecord: compassusDashboardService.updatePtoRecord,
    getMonthlyRecords: compassusDashboardService.getMonthlyRecords,
    createMonthlyRecord: compassusDashboardService.createMonthlyRecord,
    updateMonthlyRecord: compassusDashboardService.updateMonthlyRecord,
    getMonthlyAssumptions: compassusDashboardService.getMonthlyAssumptions,
    createMonthlyAssumption: compassusDashboardService.createMonthlyAssumption,
    updateMonthlyAssumption: compassusDashboardService.updateMonthlyAssumption,
    updateProviderProfile: compassusDashboardService.updateProviderProfile,
    getMyProductivity: compassusDashboardService.getMyProductivity,
    getMySchedule: compassusDashboardService.getMySchedule,
    getMyPatients: compassusDashboardService.getMyPatients,
    getNasaTlxFeedback: compassusDashboardService.getNasaTlxFeedback,
    getFacilityNpPatients: compassusDashboardService.getFacilityNpPatients,
  };
};
